import { create } from 'zustand'
import { authService } from '../services/authService'
import legalService from './legalService'

export const useAuthStore = create((set, get) => ({
  user: authService.getCurrentUser(),
  isAuthenticated: authService.isAuthenticated(),
  isInitializing: true,
  isLoading: false,
  error: null,
  legalRequiredDocs: [],
  legalGateChecked: false,

  // Register user
  register: async (name, email, password, passwordConfirmation) => {
    set({ isLoading: true, error: null })
    try {
      const response = await authService.register(name, email, password, passwordConfirmation)
      set({
        user: response.user,
        isAuthenticated: true,
        isLoading: false,
      })
      await get().refreshLegalRequired()
      return response
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || 'Registration failed'
      set({ error: errorMessage, isLoading: false })
      throw error
    }
  },

  // Login user
  login: async (email, password) => {
    set({ isLoading: true, error: null })
    try {
      const response = await authService.login(email, password)
      set({
        user: response.user,
        isAuthenticated: true,
        isLoading: false,
      })
      await get().refreshLegalRequired()
      return response
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || 'Login failed'
      set({ error: errorMessage, isLoading: false })
      throw error
    }
  },

  // Logout user
  logout: async () => {
    set({ isLoading: true })
    try {
      await authService.logout()
      set({
        user: null,
        isAuthenticated: false,
        legalRequiredDocs: [],
        legalGateChecked: false,
        error: null,
        isLoading: false,
      })
    } catch (error) {
      set({ isLoading: false })
    }
  },

  // Clear error
  clearError: () => set({ error: null }),

  // Set error
  setError: (error) => set({ error }),

  // Check if user is authenticated
  checkAuthStatus: async () => {
    const hydrated = await authService.hydrateSessionFromRefresh()
    const isAuthenticated = hydrated && authService.isAuthenticated()
    const user = authService.getCurrentUser()
    set({ isAuthenticated, user, isInitializing: false })
    if (isAuthenticated) {
      await get().refreshLegalRequired()
    } else {
      set({ legalRequiredDocs: [], legalGateChecked: true })
    }
  },

  refreshLegalRequired: async () => {
    if (!authService.isAuthenticated()) {
      set({ legalRequiredDocs: [], legalGateChecked: true })
      return []
    }
    try {
      const required = await legalService.getRequired()
      set({ legalRequiredDocs: Array.isArray(required) ? required : [], legalGateChecked: true })
      return Array.isArray(required) ? required : []
    } catch (_error) {
      set({ legalRequiredDocs: [], legalGateChecked: true })
      return []
    }
  },
}))
